export default __webpack_public_path__ + "static/media/fluster_game_background_small.399e38ed.png";